module.exports = __webpack_public_path__ + "static/venice20892-6f788440283244b023a949b4665b2b73.png";